import { appPrefixedHostWithProtocol, SHOPIFY_HEADERS, apiPrefixedHostWithProtocol, PUBLIC_HEADERS, } from "@novel/shared/utils/appConstants";
import { RestReq, } from "@novel/shared/utils/restReq";
/*
 * Typed API
 */
export class TypedPublicApi extends RestReq {
    constructor({ shop, internalSecret }) {
        super(
        // if used client-side, must use appPrefixedHostWithProtocol to avoid CORS error
        // as it must be the same domain as the script tag that loaded the app
        typeof window !== "undefined"
            ? appPrefixedHostWithProtocol
            : apiPrefixedHostWithProtocol, {
            headers: Object.assign(Object.assign({}, (!shop
                ? {}
                : {
                    [SHOPIFY_HEADERS.SHOP_DOMAIN]: shop,
                })), (!internalSecret
                ? {}
                : {
                    [PUBLIC_HEADERS.INTERNAL_CALL]: internalSecret,
                })),
        });
    }
    getReq(endpoint, requestConfig = {}) {
        return super.getReq(endpoint, requestConfig);
    }
    postReq(endpoint, requestConfig = {}) {
        return super.postReq(endpoint, requestConfig);
    }
    patchReq(endpoint, requestConfig = {}) {
        return super.patchReq(endpoint, requestConfig);
    }
    putReq(endpoint, requestConfig = {}) {
        return super.postReq(endpoint, requestConfig);
    }
    deleteReq(endpoint, requestConfig = {}) {
        return super.deleteReq(endpoint, requestConfig);
    }
}
